import React from 'react';
import PropTypes from 'prop-types';
import styles from './KycPendingFooter.module.scss';

function KycPendingFooter({ setShowKycBanner, handleKycRedirect }) {
  const dismissBanner = () => {
    sessionStorage.setItem('kycBannerDismissed', '1');
    setShowKycBanner(false);
  };

  return (
    <div className={styles.Drawer}>
      <div className={styles.kycBannerContainer}>
        {/* Left Side: Icon and Text */}
        <div className={styles.kycLeftContent}>
          <img
            src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/kyc_update.svg"
            alt="KYC"
            className={styles.kycIcon}
          />
          <span className={styles.kycText}>
            Your <b>KYC is pending &</b> may disrupt your services
          </span>
        </div>

        {/* Right Side: CTA and Close */}
        <button type="button" className={styles.kycCta} onClick={handleKycRedirect}>
          Complete KYC
        </button>

        <div
          className={styles.closeIcon}
          onClick={dismissBanner}
          role="button"
          tabIndex={0}
          aria-label="Close"
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && dismissBanner()}
        />
      </div>
    </div>
  );
}

KycPendingFooter.propTypes = {
  setShowKycBanner: PropTypes.func.isRequired,
  handleKycRedirect: PropTypes.func.isRequired,
};

export default KycPendingFooter;
